import { render, staticRenderFns } from "./SuppliersWiseProductPurchaseReport.vue?vue&type=template&id=b9ec5ad0&"
import script from "./SuppliersWiseProductPurchaseReport.vue?vue&type=script&lang=js&"
export * from "./SuppliersWiseProductPurchaseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports